let winWidth = window.outerWidth;

// Swiper Sliders
var topBarSwiper = new Swiper(".topBar_swiper", {
  slidesPerView: 2,
  loop: true,
  spaceBetween: 0,
  autoplay: true,
  autoplay: {
    delay: 4000,
  },
  breakpoints: {
    990: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

// var mainSlider = new Swiper(".main-slider", {
//   slidesPerView: 1,
//   autoplay: false,
// });

var featuredColumnSwiper = new Swiper(".featured-columns__slider", {
  slidesPerView: 1.2,
  spaceBetween: 20,
  autoplay: false,
  breakpoints: {
    750: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    1025: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  },
});

var featuredPrincessSwiper = new Swiper(".featured-princess__slider", {
  slidesPerView: 3,
  spaceBetween: 5,
  autoplay: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    750: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
    1025: {
      slidesPerView: 7,
      spaceBetween: 10,
    },
  },
});

var featuredCollSwiper = new Swiper(".featuredColl_swiper", {
  slidesPerView: 1.5,
  spaceBetween: 10,
  autoplay: false,
  breakpoints: {
    750: {
      slidesPerView: 3,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
    1025: {
      slidesPerView: 4,
      spaceBetween: 12,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
  },
});

var lookbookSwiper = new Swiper(".lookbook_swiper", {
  slidesPerView: 1.6,
  spaceBetween: 12,
  autoplay: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 2.7,
    },
    1024: {
      slidesPerView: 3.7,
      spaceBetween: 18,
    },
  },
});

// Multi column swiper
let multiColdefaults = {
  slidesPerView: 1.28,
  spaceBetween: 10,
  breakpoints: {
    750: {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
  },
};
// call init function
initMultiColumnSwipers(multiColdefaults);
function initMultiColumnSwipers(
  defaults = {},
  selector = ".multiColumn_swiper"
) {
  let swipers = document.querySelectorAll(selector);
  swipers.forEach((swiper) => {
    // get options
    let optionsData = swiper.dataset.swiper
      ? JSON.parse(swiper.dataset.swiper)
      : {};
    // combine defaults and custom options
    let options = {
      ...defaults,
      ...optionsData,
    };
    //console.log(options);
    // init
    new Swiper(swiper, options);
  });
}

var princessTabsSwiper = new Swiper(".princessTabs_swiper", {
  slidesPerView: 1.16,
  spaceBetween: 10,
  autoplay: false,
  breakpoints: {
    750: {
      slidesPerView: 1.5,
      spaceBetween: 18,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
  },
});

var princessTabsNavSwiper = new Swiper(".princessTabsNav_swiper", {
  slidesPerView: 7,
  spaceBetween: 24,
  autoplay: false,
  breakpoints: {
    750: {
      // slidesPerView: 12,
      slidesPerView: "auto",
      spaceBetween: 54,
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
    },
  },
});

// Select all tabs container elements
var tabsContainers = document.querySelectorAll(".tabs");
try{
  tabsContainers.forEach((container) => {
    var tabs = container.querySelectorAll(".tab-link");
    var tabContents = container.querySelectorAll(".tab-content");
    var tabLine = container.querySelector('.tabs .line');
  
    const initialTab = tabs[0];
    tabLine.style.width = initialTab.offsetWidth+'px';
    tabLine.style.left = initialTab.offsetLeft+'px';
  
    // Function to handle tab switching
    function switchTab(event) {
      var targetTab = event.currentTarget;
      var targetContentId = targetTab.getAttribute("data-tab-link");
  
      // Remove 'active' class from all tabs and hide all content within this container
      tabs.forEach((tab) => {
        tab.classList.remove("active");
      });
      tabContents.forEach((content) => {
        content.classList.remove("active");
      });
  
      // Add 'active' class to the clicked tab and show the corresponding content
      targetTab.classList.add("active");
      tabContents.forEach((content) => {
        if (content.id.includes(targetContentId)) {
          content.classList.add("active");
        }
      });
  
      const tabWidth = targetTab.offsetWidth;
      const tabLeft = targetTab.offsetLeft;
  
      // Animate the line
      tabLine.style.width = tabWidth+'px';
      tabLine.style.left = tabLeft+'px';
    }
    // Attach click event listener to each tab within this container
    tabs.forEach((tab) => {
      tab.addEventListener("click", switchTab);
    });
    // Set the first tab as active by default within this container
    tabs[0].classList.add("active");
    tabContents[0].classList.add("active");
  });
} catch(e) {
  console.log(e);
}


if (winWidth > 749) {
  // Footer accordion script
  var footerMenuList = document.querySelectorAll(
    ".footer-block__accordion details"
  );
  footerMenuList.forEach((menuList) => {
    menuList.setAttribute("open", false);
  });
}

// Show password
var parent = document.querySelector("form");
// password show/hide helper function
function showHide(input, showText) {
  if (input.getAttribute("type") === "password") {
    input.setAttribute("type", "text");
    showText.innerText = "hide";
  } else {
    input.setAttribute("type", "password");
    showText.innerText = "show";
  }
}
// event delegation on event target match
parent.addEventListener("click", (event) => {
  if (event.target.matches(".show-password")) {
    var spanElm = event.target;
    var inputElm = spanElm.previousElementSibling;
    showHide(inputElm, spanElm);
  }
});

// Switch toggle on Inaspiration page
// var inspRadios = document.getElementsByName("switchInspiration");
// var valRadio = [];
// for (var i=0;i<inspRadios.length;i++){
//   if ( inspRadios[i].checked ) {
//     valRadio.push(inspRadios[i].value);
//   }
// }
// localStorage.setItem('a_value', valRadio);

// document.querySelectorAll('input[name="switchInspiration"]').forEach((radio) => {
//   // var valRadio = [];
//   // for (var i=0;i<radio.length;i++){
//   //   if ( radio[i].checked ) {
//   //     valRadio.push(radio[i].value);
//   //   }
//   // }
//   // console.log('VALRADIO', valRadio);
//   radio.addEventListener("change", () => {
//     var target = document.body;
//     target.classList.remove("im_villain");
//     if (radio.id === "switchPrincess") {
//       target.classList.remove("im_villain");
//       // localStorage.setItem('radio', radio.value);
//     } else if (radio.id === "switchVillain") {
//       target.classList.add("im_villain");
//       // localStorage.setItem('radio', radio.value);
//     }
//   });
// });

// Use the 'value' of the radio button to store the theme name
// const PRINCESS_VALUE = "Princess";
const VILLAIN_VALUE = "Villain";
const STORAGE_KEY = 'radio';
function applyInspirationTheme(value) {
    const target = document.body;
    target.classList.remove("im_villain");
    if (value === VILLAIN_VALUE) {
        target.classList.add("im_villain");
    }
}
function loadSavedInspiration() {
    const savedValue = sessionStorage.getItem(STORAGE_KEY);
    if (savedValue) {
        const savedRadio = document.querySelector(
            `input[name="switchInspiration"][value="${savedValue}"]`
        );
        if (savedRadio) {
            savedRadio.checked = true;
            applyInspirationTheme(savedValue);
        }
    }
}
document.querySelectorAll('input[name="switchInspiration"]').forEach((radio) => {
    radio.addEventListener("change", () => {
        const selectedValue = radio.value;
        sessionStorage.setItem(STORAGE_KEY, selectedValue);
        applyInspirationTheme(selectedValue);
    });
});
loadSavedInspiration();

// alert(localStorage.getItem('a_value'));

// Brand story nav scroll
// window.onload = function() {
//   var brandStoryNav = document.getElementById('brandStoryNav');
//   var offset = 170; // Desired top offset
//   var brandNavPosition = brandStoryNav.getBoundingClientRect().top + window.scrollY; // Get the position of the target
//   var brandNavoffsetPosition = brandNavPosition - offset; // Adjust for the offset

//   window.scrollTo({
//       top: brandNavoffsetPosition,
//       behavior: 'auto'
//   });
// };

// if(window.innerWidth < 749) {
//   // alert('TESTING!!!');
//   var brandStoryNav = document.getElementById('brandStoryNav');
//   var brandStoryNavItem = document.querySelector('#brandStoryNav li.active');
//   var brandStoryNavWidth = brandStoryNav.offsetWidth;
//   var brandStoryNavItemWidth = brandStoryNavItem.offsetWidth;
//   var navOffset = ((brandStoryNavWidth / 2) - (brandStoryNavItemWidth / 2));
//   // eduSidebar.scrollLeft(eduSidebarItem.offset().left - offset);
//   var navItemOffsetLeft = brandStoryNavItem.offsetLeft;
//   var finalOffset = navItemOffsetLeft - navOffset;
//   window.onload = function() {
//     brandStoryNav.scrollLeft = Number(finalOffset);
//   }
// }

// Code to remove filter
if($(window).width()>989){
  $('.mobile-sidebar-filter').remove();
} else {
  $('.desktop-filter').remove();
}

/*----------------------------------------------------- 
  Product Grid and PLP Js
------------------------------------------------------*/ 
  if (winWidth < 750) {
    var collHeroSwiper = new Swiper(".collection-hero__category", {
      slidesPerView: 1.6,
      spaceBetween: 10,
      autoplay: false,
    });
  }
  
  // Handle quick look swatch click
  function product_variant_info($this,product_card_parent){
    var swatch_image = $this.attr('data-img'),
      next_image = $this.attr('data-next-img'),
      color_name = $this.attr('data-color'),
      price = $this.attr('data-price'),
      compare_price = $this.attr('data-compare-price'),
      price_without_currency = parseInt($this.attr('data-price-without-currency')),
      compare_price_without_currency = parseInt($this.attr('data-compare-price-without-currency')),
      product_url = `/products/${$this.data('product-handle')}?variant=${$this.attr('data-variant-id')}`;
      product_card_parent.find('a').attr('href',product_url);
      product_card_parent.find('.product-card__price .mm-sale-price').text(price);
      product_card_parent.find('.product-card__price .mm-original-price').text(compare_price);
      product_card_parent.find('.product-card__media').addClass('img-loading');
      product_card_parent.find('.product-main-image img').attr("src",swatch_image);
      product_card_parent.find('.product-model-image img').attr("src",next_image);
      product_card_parent.find('.product-main-image img').on('load',function(){
        product_card_parent.find('.product-card__media').removeClass("show-catalogue-image");
        product_card_parent.find('.product-card__media').removeClass('img-loading');
      })
  }
  $(document).on('click','.quick-look__wrapper .swatch',function(e) {
    $(this).closest('.option').find('.swatch').removeClass('active');
    $(this).addClass('active');
    //Select variant code
    var product_card_parent = $(this).closest('.product-card'),
    option1 = $(this).closest('.quick-look__variant-options').find('.option-1 .swatch.active').attr('data-option'),
    option2 = $(this).closest('.quick-look__variant-options').find('.option-2 .swatch.active').attr('data-option'),
    option3 = $(this).closest('.quick-look__variant-options').find('.option-3 .swatch.active').attr('data-option'),
    $this = product_card_parent.find(`[data-title="${option1}"]`);
    product_card_parent.find('.product-varaint-data div').removeClass('active');
    console.log(option1, option2, option3, !option1, !option2, !option3);
    if(!option2){
      $this.addClass('active');
      product_variant_info($this,product_card_parent);
      return false;       
    }
    if(!option3){
      $this = product_card_parent.find(`[data-title="${option1} / ${option2}"]`);
      $this.addClass('active');
      product_variant_info($this,product_card_parent);
      return false
    }
    $this = product_card_parent.find(`[data-title="${option1} / ${option2} / ${option3}"]`);
    $this.addClass('active');
    product_variant_info($this,product_card_parent);
  });

  $(document).on('click','.product-card__button .button--select-size',function(e) {
    $('.product-variants-selector').removeClass('active');
    $('.product-variants-selector .size-error').hide();
    $(this).closest('.product-card__media').find('.product-variants-selector').addClass('active');
  });
  $(document).on('click','.plp-static-product-variants .close-customize',function(e) {
    $('.product-variants-selector').removeClass('active');
  });

  $(document).on('click','.plp-product-variant',function(e) {
    var closeParent = $(this).closest('.product-variants-selector');
    closeParent.find('li').removeClass('active');
    $(this).addClass('active');
    closeParent.find('.size-error').hide();
  });

  // function addProductToCart(submitButton, closeParent,variantId) {
  //   var cart =
  //     document.querySelector("cart-notification") ||
  //     document.querySelector("cart-drawer");
  //   var config = fetchConfig("javascript");
  //   config.headers["X-Requested-With"] = "XMLHttpRequest";
  //   delete config.headers["Content-Type"];
  //   var productObj = {
  //     form_type : "product",
  //     id: variantId,
  //     quantity: 1,
  //     "product-id": closeParent.data('product-id'),
  //     utf8 : "✓"
  //   }
  //   var formData = new FormData();
  //   // Loop through the object and append each key-value pair to the FormData
  //   for (var key in productObj) {
  //     if (productObj.hasOwnProperty(key)) {
  //       formData.append(key, productObj[key]);
  //     }
  //   }
  //   if (cart) {
  //     formData.append(
  //         "sections",
  //         cart.getSectionsToRender().map((section) => section.id)
  //       );
  //       formData.append("sections_url", window.location.pathname);
  //       cart.setActiveElement(document.activeElement);
  //   }
  //   config.body = formData;
  //   console.log(productObj,config,formData,Object.fromEntries(formData));
  //   var error;

  //   submitButton.attr("aria-disabled", true);
  //   submitButton.addClass("loading");
  //   submitButton.find(".loading__spinner").removeClass("hidden");
    
  //   fetch(`${routes.cart_add_url}`, config)
  //       .then((response) => response.json())
  //       .then((response) => {
  //         console.log("response",response);
  //         if(response.status == 422) {
  //           closeParent.find('.size-error').text("You can't add more quantity to cart.").show();
  //         }
  //         if (response.status) {
  //           publish(PUB_SUB_EVENTS.cartError, {
  //             source: "product-form",
  //             productVariantId: variantId,
  //             errors: response.errors || response.description,
  //             message: response.message,
  //           });
  //           error = true;
  //           return;
  //         } else if (!cart) {
  //           window.location = window.routes.cart_url;
  //           return;
  //         }
  //         if (!error)
  //           publish(PUB_SUB_EVENTS.cartUpdate, {
  //             source: "product-form",
  //             productVariantId: variantId,
  //             cartData: response,
  //           });
  //         error = false
  //         cart.renderContents(response);
  //       })
  //       .catch((e) => {
  //         console.error(e);
  //       })
  //       .finally(() => {
  //         submitButton.removeClass("loading");
  //         if (cart && cart.classList.contains("is-empty"))
  //           cart.classList.remove("is-empty");
  //         if (!error) submitButton.removeAttr("aria-disabled");
  //         submitButton.find(".loading__spinner").addClass("hidden");
  //       });
  //   return false;
  // }

  // $(document).on('click','.product-variants-selector button:not(.loading)',function(e) {
  //   var submitButton = $(this);
  //   var closeParent = $(this).closest('.product-variants-selector');
  //   var hasSizeSelected = closeParent.find('li.active');
  //   if(!hasSizeSelected.length) {
  //     closeParent.find('.size-error').text('Please select a size.').show();
  //     return false;
  //   }
  //   var variantId;
  //   if(closeParent.hasClass('enchanted-star-variants')){
  //     variantId = $(this).closest('.product-card').find('.product-varaint-data .active').data('variant-id');
  //   } else {
  //     variantId = hasSizeSelected.data('variant-id');
  //   }
  //   addProductToCart(submitButton,closeParent, variantId)
  //   // window.location.href = `/cart/add?id=${variantId}&quantity=1`
  // })

  // $(document).on('click','.product-card__button .add-to-cart-button',function(e) {
  //   var submitButton = $(this);
  //   var closeParent = $(this).closest('form');
  //   var variantId = closeParent.find('[name="id"]').val();
  //   addProductToCart(submitButton, closeParent, variantId);
  // })

// PDP Related Products
var featuredCollSwiper = new Swiper(".relatedProducts_swiper", {
  slidesPerView: 1.5,
  spaceBetween: 10,
  autoplay: false,
  pagination: false,
  breakpoints: {
    750: {
      slidesPerView: 3,
      // spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
    1025: {
      slidesPerView: 4,
      spaceBetween: 21,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    },
  },
});

// PDP Buy now button
// $(
//   "button.shopify-payment-button__button.shopify-payment-button__button--unbranded"
// ).on("click", function (e) {
//   e.preventDefault();
//   // var variantId = $('[name="id"]').find(":selected").val();
//   var _this = $(".single__product--description");
//   var $button = $(this);
//   var $this = $(".product-form .shopify-payment-button__button");
//   var variantSKU = $(".single__product--description .variant-sku").text();
//   var productPrice = $(
//     ".single__product--description .price__stock--info .product__price"
//   ).data("product-selling-price");
//   var custom_ringsize = _this.find("#custom_ringSize option:selected").val();

//   var custom_ringEngraveText = $(".product-form-custom_ring-product-template")
//     .find("#engraving_text")
//     .val();
//   var custom_pandent_engraving = $(".engraving-accordion");

//   function ajaxAdd(data) {
//     console.log(data);
//     $.ajax({
//       url: "/cart/add.js",
//       dataType: "json",
//       cache: false,
//       type: "post",
//       data: data,
//       beforeSend: function () {
//         $button.find(".checkout-text").addClass("hide");
//         $button.find("[data-loader]").removeClass("hide");
//       },
//       success: function (data) {
//         console.log(data);
//         if (productPrice > 29900 && theme.isFreeProductAvailable) {
//           var freeProduct = {
//             id: 39538128945223,
//             quantity: 1,
//           };
//           $.ajax({
//             url: "/cart/add.js",
//             dataType: "json",
//             cache: false,
//             type: "post",
//             data: freeProduct,
//             success: function () {
//               window.location = "/checkout";
//             },
//           });
//         } else {
//           window.location = "/checkout";
//         }
//       },
//       error: function (error) {
//         console.log("error", error.responseJSON.description);
//         $this
//           .siblings(".error_message")
//           .removeClass("hide")
//           .text(error.responseJSON.description);
//         $button.find("span").removeClass("hide");
//         $button.find("[data-loader]").addClass("hide");
//       },
//     });
//   }
//   $.ajax({
//     type: "POST",
//     url: "/cart/clear.js",
//     dataType: "json",
//     success: function () {
//       ajaxAdd(
//         ProductFormData(
//           $this,
//           variantSKU,
//           custom_ringsize,
//           custom_ringEngraveText,
//           custom_pandent_engraving
//         )
//       );
//     },
//     error: function (error) {
//       console.log("error", error.responseJSON.description);
//     },
//   });
// });

$(".faq--accordion .accordion-header:first-of-type")
  .addClass("active")
  .next()
  .show();

$(".faq--accordion").on("click", ".accordion-header", function () {
  $(this).toggleClass("active").next().slideToggle();
  $(".accordion-header").not(this).removeClass("active").next().slideUp();
});
